import axios from "axios";
import React, {useState, useEffect} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function OpInvoice(props) {
    const {sale_op} = useParams();
    const [opbillData, setopbillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'op-invoice/' + sale_op)
                .then(function (response) {
                    setopbillData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };

    function numberToWords(num) {
        const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quattuordecillion', 'quindecillion', 'sexdecillion', 'septendecillion', 'octodecillion', 'novemdecillion', 'vigintillion'];

        function convertThreeDigitsLessThanThousand(num) {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            const onesDigit = num % 10;
            const tensDigit = Math.floor((num % 100) / 10);
            const hundredsDigit = Math.floor(num / 100);
            let result = '';
            if (hundredsDigit > 0) {
                result = `${units[hundredsDigit]} hundred`;
            }
            if (tensDigit > 0) {
                if (result) result += ' and ';
                if (tensDigit === 1) {
                    result += teens[onesDigit];
                } else if (onesDigit === 0) {
                    result += tens[tensDigit];
                } else {
                    result += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            } else if (onesDigit > 0) {
                if (result) result += ' and ';
                result += units[onesDigit];
            }
            return result;
        }

        function convertThreeDigits(num) {
            if (num === 0) return 'zero';
            if (num < 1000) return convertThreeDigitsLessThanThousand(num);
            let words = '';
            let scaleIndex = 0;
            while (num > 0) {
                const currentNum = num % 1000;
                if (currentNum !== 0) {
                    const currentWords = convertThreeDigitsLessThanThousand(currentNum);
                    if (scaleIndex > 0) {
                        words = `${currentWords} ${scales[scaleIndex]} ${words}`;
                    } else {
                        words = `${currentWords} ${words}`;
                    }
                }
                scaleIndex++;
                num = Math.floor(num / 1000);
            }
            return words.trim();
        }

        if (num === 10000) {
            return 'ten thousand rupees only';
        }
        if (num === 0) {
            return 'zero rupees only';
        }
        if (num < 0) return `negative ${numberToWords(Math.abs(num))}`;
        const parts = num.toString().split('.');
        let integerPart = parseInt(parts[0], 10);
        let decimalPart = parseInt(parts[1], 10) || 0;
        let words = '';
        let scaleIndex = 0;
        // Convert integer part
        while (integerPart > 0) {
            const hundreds = integerPart % 1000;
            if (hundreds !== 0) {
                const hundredsWords = convertThreeDigits(hundreds);
                if (scaleIndex !== 0) {
                    words = `${hundredsWords} ${scales[scaleIndex]} ${words}`;
                } else {
                    words = `${hundredsWords} ${words}`;
                }
            }
            scaleIndex++;
            integerPart = Math.floor(integerPart / 1000);
        }
        // Convert decimal part
        if (decimalPart > 0) {
            words += ' and ';
            if (decimalPart < 10) {
                words += units[decimalPart];
            } else if (decimalPart < 20) {
                words += teens[decimalPart - 11];
            } else {
                const onesDigit = decimalPart % 10;
                const tensDigit = Math.floor(decimalPart / 10);
                if (onesDigit === 0) {
                    words += tens[tensDigit];
                } else {
                    words += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            }
            words += ' paisa';
        }
        words += ' rupees only';
        return words.trim();
    }

    return (
        <section>
            <div>
                {opbillData.map((row, index) =>
                    <div
                        id="invoice-print"
                        style={{
                            width: "900px",
                            margin: "15px auto",
                            border: "2px solid #000",
                            fontFamily: "Arial",
                            fontSize: "14px",
                            color: "#000",
                            background: "#fff"
                        }}
                    >
                        {hospData.map((hospital) => (
                            <table
                                key={hospital.id}
                                width="100%"
                                style={{
                                    borderCollapse: "collapse",
                                    border: "2px solid #000"
                                }}
                            >
                                <tbody>
                                {/*================ HEADER =================*/}
                                <tr>
                                    <td
                                        rowSpan="2"
                                        style={{
                                            width: "170px",
                                            border: "2px solid #000",
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            padding: "10px"
                                        }}
                                    >
                                        <img
                                            src={hospital.logo}
                                            style={{
                                                width: "90px",
                                                height: "90px",
                                                objectFit: "contain"
                                            }}
                                        />
                                    </td>
                                    <td
                                        style={{
                                            border: "2px solid #000",
                                            textAlign: "center",
                                            padding: "8px 15px"
                                        }}
                                    >
                                        <h2
                                            style={{
                                                margin: 0,
                                                fontSize: "28px",
                                                fontWeight: "700",
                                                letterSpacing: "2px"
                                            }}
                                        >
                                            {hospital.hospital}
                                        </h2>
                                        <div
                                            style={{
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                marginTop: "3px"
                                            }}
                                        >
                                            UNIT OF VP GLOBAL HEALTH SYNDICATE PRIVATE LIMITED
                                        </div>
                                        <div
                                            style={{
                                                marginTop: "8px",
                                                fontSize: "13px",
                                                lineHeight: "1.5",
                                                width: "100%",
                                                textAlign: "center",
                                                wordBreak: "break-word"
                                            }}
                                        >
                                            {hospital.address}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            border: "2px solid #000",
                                            padding: "6px 10px"
                                        }}
                                    >
                                        <table
                                            width="100%"
                                            style={{
                                                borderCollapse: "collapse",
                                                fontSize: "13px"
                                            }}
                                        >
                                            <tbody>
                                            <tr>
                                                <td style={{width: "50%", textAlign: "left"}}>
                                                    <strong>GSTIN :</strong> {hospital.gst}
                                                </td>
                                                <td style={{width: "50%", textAlign: "left"}}>
                                                    <strong>EMAIL :</strong> {hospital.email}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{textAlign: "left", paddingTop: "4px"}}>
                                                    <strong>MOBILE :</strong> {hospital.mobile}
                                                </td>
                                                <td style={{textAlign: "left", paddingTop: "4px"}}>
                                                    <strong>LANDLINE :</strong> {hospital.landline}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {/*============== PATIENT DETAILS =================*/}
                                <tr>
                                    <td
                                        colSpan="2"
                                        style={{
                                            padding: 0,
                                            border: "2px solid #000"
                                        }}
                                    >
                                        <table
                                            width="100%"

                                        >
                                            <tbody>
                                            <tr>
                                                <td
                                                    style={{
                                                        width: "55%",
                                                        padding: "8px"
                                                    }}
                                                >
                                                    <b>NAME :</b>
                                                    {row.pat.patient}
                                                </td>
                                                <td
                                                    style={{
                                                        borderLeft: "2px solid #000",
                                                        padding: "8px"
                                                    }}
                                                >
                                                    <b>INVOICE NO :</b>
                                                    HLH 26-27/ {row.invoice}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style={{padding: "8px"}}
                                                >
                                                    <b>PID :</b>
                                                    {row.pat.pat_id}
                                                </td>
                                                <td
                                                    style={{
                                                        borderLeft: "2px solid #000",
                                                        padding: "8px"
                                                    }}
                                                >
                                                    <b>INVOICE DATE :</b>
                                                    {row.add_date}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style={{padding: "8px"}}
                                                >
                                                    <b>DOCTOR :</b>
                                                    Dr. {row.cons.consultant}
                                                </td>
                                                <td
                                                    style={{
                                                        borderLeft: "2px solid #000",
                                                        padding: "8px"
                                                    }}
                                                >
                                                    <b>PAYMENT DETAILS:</b>
                                                    {row.mode.toUpperCase()}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {/*============== BILL =================*/}
                                <tr>
                                    <td
                                        colSpan="2"
                                        style={{padding: 0}}
                                    >
                                        <table
                                            width="100%"
                                            
                                        >
                                            <thead>
                                            <tr
                                                style={{
                                                    background: "#f2f2f2"
                                                }}
                                            >
                                                <th style={{border: "2px solid #000"}}>S.NO</th>
                                                <th style={{border: "2px solid #000"}}>
                                                    PARTICULARS
                                                </th>
                                                <th style={{border: "2px solid #000"}}>
                                                    HSN/SAC
                                                </th>
                                                <th style={{border: "2px solid #000"}}>
                                                    TAX
                                                </th>
                                                <th style={{border: "2px solid #000"}}>
                                                    TAXABLE AMOUNT
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    1
                                                </td>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        padding: "8px"
                                                    }}
                                                >
                                                    CONSULTATION FEES
                                                </td>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    999312
                                                </td>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    EXEMPTED
                                                </td>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "right",
                                                        paddingRight: "10px"
                                                    }}
                                                >
                                                    ₹ {row.fee}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "right",
                                                        paddingRight: "10px",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    TOTAL INVOICE AMOUNT
                                                </td>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "right",
                                                        paddingRight: "10px"
                                                    }}
                                                >
                                                    ₹ {row.fee}
                                                </td>
                                            </tr>
                                            {row.disc > 0 && (
                                                <tr>
                                                    <td colSpan="4"
                                                        style={{
                                                            border: "2px solid #000",
                                                            textAlign: "right",
                                                            paddingRight: "10px"
                                                        }}
                                                    >
                                                        DISCOUNT
                                                    </td>
                                                    <td
                                                        style={{
                                                            border: "2px solid #000",
                                                            textAlign: "right",
                                                            paddingRight: "10px"
                                                        }}
                                                    >
                                                        ₹ {row.disc}
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "right",
                                                        paddingRight: "10px",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    TOTAL PAID
                                                </td>
                                                <td
                                                    style={{
                                                        border: "2px solid #000",
                                                        textAlign: "right",
                                                        paddingRight: "10px",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    ₹ {row.paid}
                                                </td>
                                            </tr>
                                            {row.balance > 0 && (
                                                <tr>
                                                    <td
                                                        colSpan="4"
                                                        style={{
                                                            border: "2px solid #000",
                                                            textAlign: "right",
                                                            paddingRight: "10px"
                                                        }}
                                                    >
                                                        BALANCE
                                                    </td>
                                                    <td
                                                        style={{
                                                            border: "2px solid #000",
                                                            textAlign: "right",
                                                            paddingRight: "10px"
                                                        }}
                                                    >
                                                        ₹ {row.balance}
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {/*============== FOOTER =================*/}
                                <tr>
                                    <td
                                        colSpan="2"
                                        style={{
                                            padding: "15px"
                                        }}
                                    >
                                        <table
                                            width="100%"
                                            style={{
                                                borderCollapse: "collapse"
                                            }}
                                        >
                                            <tbody>
                                            <tr>
                                                <td
                                                    style={{
                                                        width: "75%",
                                                        fontWeight: "bold",
                                                        verticalAlign: "top"
                                                    }}
                                                >
                                                    RUPEES IN WORDS :
                                                    <br/>
                                                    <span
                                                        style={{
                                                            fontWeight: "normal",
                                                            fontSize: "15px"
                                                        }}
                                                    >
                    {numberToWords(parseFloat(row.paid)).toUpperCase()}
                    </span>
                                                </td>
                                                <td
                                                    style={{
                                                        width: "25%",
                                                        textAlign: "center",
                                                        verticalAlign: "bottom"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            marginTop: "30px",
                                                            fontWeight: "600"
                                                        }}
                                                    >
                                                        {row.cashier}
                                                    </div>
                                                    <div
                                                        style={{
                                                            marginTop: "35px",
                                                            borderTop: "2px solid black",
                                                            paddingTop: "5px",
                                                            display: "inline-block",
                                                            minWidth: "140px"
                                                        }}
                                                    >
                                                        Cashier
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        ))}
                    </div>
                )}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}

export default OpInvoice;